module.exports = __webpack_public_path__ + "static/design01-c792f84adb14c9eef95c467596454ae2.jpg";